import { defineComponent } from 'vue';
import MyNavBar from '@/components/MyNavBar.vue';

export default defineComponent({
  components: {
    'my-nav-bar': MyNavBar,
  },
});
